import { LegalPageLayout } from '../components/LegalPageLayout';

export function Component() {
  return <LegalPageLayout pageId="privacy" i18nPrefix="privacy" />;
}
